const t = (e) => {
  const { landingUrl: n, query: r } = e;
  return `${n}?swsquery=${encodeURIComponent(r)}&querycat=helpcenter_search_dropdown`;
};
export {
  t as getDestinationUrl
};
//# sourceMappingURL=help-center-articles-search17.js.map
